// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    regional: "Regional settings",
    description: "Configure date and number formats, time zone and languages",
    formats: "Formats",
    formatsDescription:
      "How dates and numbers are displayed across the app, client-facing flows, and generated PDFs.",
    dateFormat: "Date format",
    decimalSeparator: "Decimal separator",
    thousandSeparator: "Thousand separator",
    timeZone: "Time zone",
    timeZoneDescription:
      "The tenant's local time zone. Generated PDFs print today's date and timestamps (for example when a Trapets, ENIN or Sumsub check ran) in this zone.",
    timeZoneSearchPlaceholder: "Search time zones…",
    timeZoneNoResults: "No matching time zones.",
    localTimeNow: "Local time now",
    separatorNames: {
      comma: "Comma",
      period: "Period",
      space: "Space",
      apostrophe: "Apostrophe",
      none: "None",
    } as Record<string, string>,
    preview: "Preview",
    currency: "Currency",
    currencyDescription:
      "The tenant's reporting currency — the basis for the Cash client filter and its threshold values. Synced account balances are converted into this currency.",
    defaultLanguage: "Default Language",
    defaultLanguageDescription:
      "The primary language for new content. This is used as a fallback when translations are missing.",
    supportedLanguages: "Supported Languages",
    supportedLanguagesDescription:
      "Languages available for content translation. Users can add translations for these languages.",
    default: "default",
    comingSoon: "Additional languages are coming soon.",
    error: "Error",
    failedToSave: "Failed to save regional settings",
    saved: "Saved",
    save: "Save",
  },
  nb_NO: {
    settings: "Innstillinger",
    regional: "Regionale innstillinger",
    description: "Konfigurer dato- og tallformater, tidssone og språk",
    formats: "Formater",
    formatsDescription: "Hvordan datoer og tall vises i appen, kundeflyter og genererte PDF-er.",
    dateFormat: "Datoformat",
    decimalSeparator: "Desimaltegn",
    thousandSeparator: "Tusenskilletegn",
    timeZone: "Tidssone",
    timeZoneDescription:
      "Tenantens lokale tidssone. Genererte PDF-er skriver dagens dato og tidspunkter (for eksempel når et Trapets-, ENIN- eller Sumsub-oppslag ble gjort) i denne tidssonen.",
    timeZoneSearchPlaceholder: "Søk etter tidssoner…",
    timeZoneNoResults: "Ingen tidssoner samsvarer.",
    localTimeNow: "Lokal tid nå",
    separatorNames: {
      comma: "Komma",
      period: "Punktum",
      space: "Mellomrom",
      apostrophe: "Apostrof",
      none: "Ingen",
    } as Record<string, string>,
    preview: "Forhåndsvisning",
    currency: "Valuta",
    currencyDescription:
      "Tenantens rapporteringsvaluta — grunnlaget for kontantfilteret på kundelisten og dets terskelverdier. Synkroniserte kontosaldoer konverteres til denne valutaen.",
    defaultLanguage: "Standardspråk",
    defaultLanguageDescription:
      "Hovedspråket for nytt innhold. Dette brukes som fallback når oversettelser mangler.",
    supportedLanguages: "Støttede språk",
    supportedLanguagesDescription:
      "Språk tilgjengelig for innholdsoversettelse. Brukere kan legge til oversettelser for disse språkene.",
    default: "standard",
    comingSoon: "Flere språk kommer snart.",
    error: "Feil",
    failedToSave: "Kunne ikke lagre regionale innstillinger",
    saved: "Lagret",
    save: "Lagre",
  },
} as const;
